<template>
  <div class="scaler flex items-center" v-if="store.getters['app/croppedCanvasWidth']">
    <a-tooltip placement="top" :title="t('common.zoomOut')">
      <MinusOutlined :class="{ disabled: disabledMin }" @click="setScale(-0.05)" />
    </a-tooltip>
    <div class="toggle">
      <div class="icons">
        <a-tooltip v-if="canvasScale === 1" placement="top" :title="t('common.fitScreen')">
          <FullscreenExitOutlined @click="setFill" />
        </a-tooltip>
        <a-tooltip v-else placement="top" :title="t('common.actualSize')">
          <FullscreenOutlined @click="setScale(1, true)" />
        </a-tooltip>
      </div>
      <div class="num">{{ canvasScale4show }}%</div>
    </div>
    <a-tooltip placement="top" :title="t('common.zoomIn')">
      <PlusOutlined :class="{ disabled: disabledMax }" @click="setScale(0.05)" />
    </a-tooltip>
  </div>
</template>
<script setup>
import { computed, nextTick, watch } from 'vue';
import { MinusOutlined, PlusOutlined, FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons-vue';
import { useStore } from 'vuex';
import { debounce } from 'lodash-es';
import useSize from '../useSize';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
const store = useStore();
const appState = computed(() => store.state.app);
const isCanvasReady = computed(() => appState.value.editorSize.canvasReady);
const isCropPanel = computed(() => appState.value.currentMenuAction === 'crop');
const canvasScale = computed(() => appState.value.canvasScale);
const canvasScale4show = computed(() => Math.ceil(canvasScale.value * 100));
const setScale = (delta, abs) => {
  const result = abs ? delta : Number(canvasScale.value) + delta;
  store.dispatch('app/setCanvasScale', result);
};
const disabledMax = computed(() => store.getters['app/disabledScaleLarger']);
const disabledMin = computed(() => store.getters['app/disabledScaleSmaller']);

const { resetEditorSize } = useSize({ appState });
const setFill = () => {
  const { editorSize } = appState.value;
  const { wrapWidth, wrapHeight } = editorSize;
  const canvasWidth = isCropPanel ? editorSize.canvasWidth : store.getters['app/croppedCanvasWidth'];
  const canvasHeight = isCropPanel ? editorSize.canvasHeight : store.getters['app/croppedCanvasHeight'];
  const wrapRatio = wrapWidth / wrapHeight;
  const canvasRatio = canvasWidth / canvasHeight;
  if (!canvasHeight) return;
  // console.log(123, { wrapWidth, wrapHeight, wrapRatio, canvasRatio });
  if (wrapRatio > canvasRatio) {
    store.dispatch('app/setCanvasScale', wrapHeight / canvasHeight);
  } else {
    store.dispatch('app/setCanvasScale', wrapWidth / canvasWidth);
  }
};

const onWindowResize = debounce(() => {
  console.log('onWindowResize');
  resetEditorSize();
  setFill();
});

window.addEventListener('resize', () => {
  nextTick(onWindowResize);
});

watch(isCanvasReady, nv => nv && nextTick(setFill), { immediate: true });
watch(isCropPanel, nv => nv && nextTick(setFill), { immediate: true });
</script>
<style lang="less" scoped>
@width: 40px;
.scaler {
  display: flex;
  align-items: center;
  padding: 3px 6px;
  font-size: 18px;
  border-radius: 4px;
  text-align: center;
  user-select: none;
  // border: 1px solid rgba(0, 0, 0, 0.08);
  // color: #fff;
  &:hover {
    .expand-wrap {
      width: @width * 2;
    }
  }
}
.anticon {
  cursor: pointer;
  padding: 0 8px;
  font-weight: bold;
  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}
.toggle {
  width: 40px;
  cursor: pointer;
  &:hover {
    .num {
      display: none;
    }
    .icons {
      display: block;
    }
  }
}
.icons {
  display: none;
}
.num {
  font-size: 14px;
}
</style>
